import { observer } from 'mobx-react'
import { FC } from 'react'

import { FlexContainer, Tooltip } from '@avantstay/backoffice-core'

import { casesFilterOptionsStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFilterOptionsStore'

interface PropertyPreviewFormatterProps {
  values?: string[]
}

const _PropertyPreviewFormatter: FC<PropertyPreviewFormatterProps> = ({ values }) => {
  const { propertiesOptions, isLoadingProperties } = casesFilterOptionsStore
  if (isLoadingProperties) return '...'

  const selectedProperties =
    values?.map(value => propertiesOptions?.find(option => option?.value === value)?.label) ?? []

  const parsedText =
    selectedProperties.length > 1
      ? `${selectedProperties[0]}, + ${selectedProperties.length - 1}`
      : selectedProperties?.[0]

  return (
    <Tooltip
      content={
        <FlexContainer direction="column" alignItems="flex-start">
          {selectedProperties.map(name => (
            <p key={name}>{name}</p>
          ))}
        </FlexContainer>
      }
      disabled={selectedProperties.length === 0}
    >
      <p>{parsedText}</p>
    </Tooltip>
  )
}

export const PropertyPreviewFormatter = observer(_PropertyPreviewFormatter)
